import fs from 'node:fs';
import path from 'node:path';
import os from 'node:os';

/**
 * Path to the CLI's local SQLite database (WASM-backed).
 * Override with `BUILDAMATON_CLI_SQLITE_PATH` for tests or custom layouts.
 */
export function getCliSqlitePath(): string {
  const override = process.env.BUILDAMATON_CLI_SQLITE_PATH?.trim();
  if (override) return path.resolve(override);
  return path.join(os.homedir(), '.buildautomaton', 'cli.sqlite');
}

export function ensureCliSqliteParentDir(sqlitePath: string): void {
  const dir = path.dirname(sqlitePath);
  if (!fs.existsSync(dir)) fs.mkdirSync(dir, { recursive: true });
}
